/**
 * Copyright (C) 2017 Trend Micro Inc. All rights reserved.
 *
 * This module defines methods for calling the API that include error handling.
 */

import { API_DOMAIN } from 'constants.js';
import { getFeedPath, LOCALE } from 'utils/environment';

/**
 * Perform a GET request to the DSM API
 *
 * @param {string} url The api path to fetch. Example '/rest/session'
 * @param {object} queryParams A object of key value pairs to be used as query parameters
 * @returns {Promise} A promise that resolves with the parsed JSON of response,
 *     otherwise rejects with the error cause.
 */
export function doGet(url, queryParams = {}) {
  return apiFetch(url, queryParams, {
    method: 'GET',
  })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error(`GET request to "${url}" failed`, error, error.response);
      return Promise.reject(error);
    });
}

function apiFetch(file, queryParams, options) {
  return fetch(`${API_DOMAIN}/${getFeedPath()}/${LOCALE}/${file}`, {
    credentials: 'same-origin',
    ...options,
  }).then(response => {
    if (!response.ok) {
      throw wrappedError(new Error(`Response status was not ok: ${response.status}`), { response });
    }
    return response;
  });
}

function wrappedError(error, details) {
  Object.assign(error, details);
  return error;
}
